import { Box, FormControl, FormLabel, Select, Text, Flex, Alert, AlertIcon, AlertTitle } from '@chakra-ui/react'

export function ItemSelector({ itensTroca, selectedSequence, setSelectedSequence, isLoading }) {
  if (!itensTroca || itensTroca.length === 0) {
    return (
      <Alert
        status="info"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        borderRadius="lg"
        p={5}
        mb={6}
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Nenhum item com troca pendente
        </AlertTitle>
        <Text>Não há itens com troca solicitada para este pedido.</Text>
      </Alert>
    )
  }

  return (
    <Box mb={6} bg="#3a4a53" p={5} borderRadius="lg" shadow="md">
      <FormControl>
        <FormLabel color="white" fontWeight="medium">
          Selecione um item para confirmar o recebimento
        </FormLabel>

        <Select
          value={selectedSequence}
          onChange={(e) => setSelectedSequence(e.target.value)}
          bg="#4a5a64"
          color="white"
          placeholder="Selecione um item"
          isDisabled={isLoading}
          _focus={{
            borderColor: '#37F091',
            boxShadow: '0 0 0 1px #37F091',
          }}
        >
          {itensTroca.map((item) => (
            <option key={item.sequencia} value={item.sequencia} style={{ background: '#4a5a64' }}>
              {`${item.sequencia} - ${item.codigo_produto} - ${item.descricao || item.descricao_produto} (Qtd: ${item.quantidade})`}
            </option>
          ))}
        </Select>

        <Flex mt={2} justify="space-between" fontSize="sm" color="gray.300">
          <Text>{itensTroca.length} item(ns) com troca pendente</Text>
          <Text>Selecione um item para prosseguir</Text>
        </Flex>
      </FormControl>
    </Box>
  )
}
